<template>
    <div class="body-date" :style="{opacity: waitState ? 0.3: 1}">
        <div class="mask-all" v-show="waitState"></div>
        <div class="row-top">
            <div class="text-year-month">
                <span class="my-cursor" @click.stop="switchMonth()">{{ titleDate }}</span>
            </div>
            <div class="icon-prev my-cursor" @click.stop="flipCycle('prev')"></div>
            <div class="icon-next my-cursor" @click.stop="flipCycle('next')"></div>
        </div>
        <div class="row-month" v-show="monthState">
            <div class="item-month my-cursor"
                 :style="{'border-color': monthIndex + 1 === monthNum? '#000000':'transparent'}"
                 @click.stop="setSelectMonth(monthIndex + 1)"
                 v-for="(monthItem, monthIndex) in monthItems">{{ monthItem }}</div>
        </div>
        <div class="row-week" v-show="!monthState">
            <div class="item-week" v-for="weekItem in weekItems">{{ weekItem }}</div>
        </div>

        <div class="row-day" v-show="!monthState">
            <div class="item-day" v-for="dayItem in dayItems">
                <div class="day-border my-cursor" :class="[
                    {'is-today': dayItem.isToday},
                    {'is-click': dayItem.isClick},
                    {'is-same': dayItem.sameMonth}
                ]" @click.stop="setSelectDay(dayItem)">
                    <div class="icon-work" v-if="dayItem.isWork === 1"></div>
                    <div class="icon-rest" v-if="dayItem.isWork === 2"></div>

                    <div class="text-day">{{ dayItem.day }}</div>
                    <div class="text-lunar-day" :class="{'text-lunar-color': dayItem.sameMonth && dayItem.viceColor}">
                        {{ dayItem.viceDay }}
                    </div>
                    <div class="item-point" v-show="dayItem.matterArray.length > 0"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listShowInfo from "@/utils/List/listShowInfo";

export default {
    name: "Calendar",
    data(){
        return {
            monthItems: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], // 月标识
            weekItems: ["一", "二", "三", "四", "五", "六", "日"], // 周标识
            dayItems: [],
            selectDayStr: "",
            titleDate: "",
            solarMonth: {},
            solarYear: {},
            monthNum: {},
            monthState: false,
        }
    },
    props:{
        waitState: {
            type: Boolean,
            default: false,
        },
    },


    methods: {
        /**
         * 月选择模块
         */
        switchMonth: function(){
            this.monthState = !this.monthState;
            if(this.monthState){
                this.solarYear = SolarYear.fromYear(this.solarMonth.getYear());
                this.titleDate = this.solarYear.getYear() + "年";
            }else{
                this.titleDate = this.solarMonth.getYear() + "年" + this.$Utils.addZero(this.solarMonth.getMonth()) + "月";
            }
        },
        // 获取年切换时的标题
        getCycleMonthItems: function(flipType){
            if(flipType === "prev"){
                this.solarYear = this.solarYear.next(-1);
            }else if(flipType === "next"){
                this.solarYear = this.solarYear.next(1);
            }
            this.titleDate = this.solarYear.getYear() + "年";
        },
        // 选择
        setSelectMonth: function(monthType){
            this.solarMonth = SolarMonth.fromYm(this.solarYear.getYear(), monthType);
            this.switchMonth();
            this.updateDayItems();
        },
        /**
         * 切换 月/年
         * @param flipType prev、next
         */
        flipCycle: function(flipType){
            if(this.monthState){
                this.getCycleMonthItems(flipType);
            }else{
                this.getCycleDayItems(flipType);
            }
        },

        getCycleDayItems: function(monthType){
            if(monthType === "prev"){
                this.solarMonth = this.solarMonth.next(-1);
            }else if(monthType === "next"){
                this.solarMonth = this.solarMonth.next(1);
            }else{
                this.solarMonth = SolarMonth.fromDate(new Date());
            }
            this.titleDate = this.solarMonth.getYear() + "年" + this.$Utils.addZero(this.solarMonth.getMonth()) + "月";
            // 获取每一天
            this.updateDayItems();
        },
        updateDayItems: function(){

            let dayItems = this.$Utils.getMonthDays(this.solarMonth);
            const monthNum = this.solarMonth.getMonth();

            dayItems.forEach((item, index, array)=>{
                const itemYmd = item.toYmd();
                const isWork = this.$Utils.checkWork(itemYmd);
                let sameMonth = item.getMonth() === monthNum;
                let isToday = itemYmd === this.todayStr;
                if(isToday && this.selectDayStr === ""){
                    this.selectDayStr = itemYmd;
                }
                const isClick = itemYmd === this.selectDayStr;

                const viceItem = this.$Utils.getViceDay(item);
                array[index] = {
                    day: item.getDay(),
                    viceDay: viceItem.viceDay,
                    viceColor: viceItem.viceColor,
                    isWork: isWork,
                    weekday: item.getWeekInChinese(),
                    sameMonth: sameMonth,
                    isToday: isToday,
                    isClick: isClick,
                    date: item.toYmd(),
                    matterArray: [],
                }
            });
            this.dayItems = dayItems;
            this.monthNum = monthNum;
            this.setDayMatters();
        },
        setDayMatters: function(){
            listShowInfo.setMonthDays(this.dayItems);
        },
        setSelectDay: function(dayItem){
            if(dayItem.isClick){
                return
            }
            this.selectDayStr = dayItem.date;
            this.dayItems.forEach((item)=>{
                item.isClick = item.date === this.selectDayStr;
            })
            this.$emit("submitEvent", dayItem);
        },
    },
    mounted(){
        this.todayStr = Solar.fromDate(new Date()).toYmd();
        this.getCycleDayItems('current');
    },
}
</script>

<style scoped>
div.body-date{
    width: 100%;
    position: relative;
    opacity: 0.3;
}
div.mask-all{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index:1;
}
div.row-top{
    width: 100%;
    height: 0.56rem;
    box-sizing: border-box;
    padding: 0 0.16rem;
    display: flex;
    align-items: center;
}
div.text-year-month{
    flex: 1;
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.19rem;
    text-align: left;
    font-style: normal;
}
div.icon-prev, div.icon-next{
    width: 0.13rem;
    height: 0.08rem;
    float: right;
}
div.icon-prev{
    background: url("../../../assets/images/List/icon-prev.png");
    background-size: cover;
    margin-right: 0.17rem;
}
div.icon-next{
    background: url("../../../assets/images/List/icon-next.png");
    background-size: cover;
}
div.row-month{
    width: 100%;
    /*height: 3.02rem;*/
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.14rem;
    column-gap: 0.35rem;
    justify-content: space-evenly;
}
div.item-month{
    width: 0.7rem;
    height: 0.64rem;
    background: rgba(255, 239, 180, 1);
    border-radius: 0.08rem;
    border: 0.02rem solid #000000;
    box-sizing: border-box;
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.6rem;
    text-align: center;
}
div.row-week{
    width: 100%;
    height: 0.32rem;
    display: flex;
    align-items: center;
    font-family: PF-Regular, sans-serif;
    font-size: 0.13rem;
    color: #000000;
    font-style: normal;
    text-align: center;
    opacity: 0.5;
}
div.item-week{
    flex: 1;
}
div.row-day{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
div.item-day{
    width: calc(100% / 7);
    height: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

}

div.day-border{
    width: 0.36rem;
    height: 0.36rem;
    border-radius: 50%;
    border: 0.02rem solid transparent;
    box-sizing: border-box;
}
div.icon-work, div.icon-rest{
    width: 0.1rem;
    height: 0.1rem;
    position: absolute;
    margin-left: 0.26rem;
}
div.icon-work{
    background: url("../../../assets/images/List/icon-work.png");
    background-size: cover;
}
div.icon-rest{
    background: url("../../../assets/images/List/icon-rest.png");
    background-size: cover;
}
div.text-day{
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.15rem;
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
    font-style: normal;
}
div.text-lunar-day{
    width: 0.44rem;
    font-size:.12rem;
    transform:scale(.8);
    font-family: PF-Regular, sans-serif;
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
    margin-top: -0.05rem;
    margin-left: -0.06rem;
}
div.is-same div.text-day, div.text-lunar-color{
    color: #000000;
}
div.is-today{
    background: var(--color-3);
    border-color: var(--color-3);
}
div.is-click{
    border-color: var(--color-3);
}
div.item-point{
    width: 0.05rem;
    height: 0.05rem;
    border-radius: 50%;
    background: #FC8470;
    margin: auto;
}
</style>